export default "__VITE_ASSET__2dc9bc2b__"